<div class="size">
  <mat-icon svgIcon="font-size"></mat-icon>
  <input type="range" [min]="minDisplayFontSize" [max]="maxDisplayFontSize"
         [value]="_fontSize"
          #input
         [attr.disabled]="enabled ? undefined : true"
         (input)="setFontSize($event.target.value)"
         step="1">
  <div class="current">{{_fontSize}}</div>
</div>
